<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@accessReportDialog-accessReport">Access Report</h2>
		<button mat-icon-button>
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="access-report-close-button"
				>close</mat-icon
			>
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		<h3 class="drawer-dialog-content-header" i18n="@@accessReportDialog-devices">Devices</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				[allDropdownOptions]="deviceOptions"
				[filterOnField]="'serialNumber'"
				data-automation-id="serial-number-typeahead"
				[placeholderText]="this.deviceMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="deviceIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
				(searchInputChanged)="onSearchInput('device', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		@if (this.isSentrilock) {
			<div>
				<mat-divider></mat-divider>
				<h3 class="drawer-dialog-content-header" i18n="@@accessReportDialog-deviceOwners">Device Owners</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						[allDropdownOptions]="deviceOwnerOptions"
						[filterOnField]="'name'"
						data-automation-id="device-owner-typeahead"
						[placeholderText]="this.deviceOwnerMultiSelectorSearchPlaceHolder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-nav-work'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="deviceOwnersCompanyIds"
						[minCharactersForSearch]="3"
						[initiallySelectedIdField]="'id'"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceOwner', $event)"
						(searchInputChanged)="onSearchInput('deviceOwner', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>
		}

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@accessReportDialog-accessedByCompany">Accessed By Company</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				[allDropdownOptions]="accessedByCompanyOptions"
				[filterOnField]="'name'"
				data-automation-id="company-access-typeahead"
				[placeholderText]="this.accessedByCompanyMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="accessedByCompanyIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('company', $event)"
				(searchInputChanged)="onSearchInput('company', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@accessReportDialog-accessByUser">Accessed By User</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				[allDropdownOptions]="accessedByUserOptions"
				[filterOnField]="'displayName'"
				data-automation-id="accessed-by-typeahead"
				[placeholderText]="this.accessedByUserMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-add-user'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="accessedByUserIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('user', $event)"
				(searchInputChanged)="onSearchInput('user', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		@if (isCareCompany) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientFirstName">Client First Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="first-name-typeahead"
						[allDropdownOptions]="firstNames"
						[filterOnField]="'firstName'"
						[placeholderText]="this.firstNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="firstName"
						[initiallySelectedIdField]="'firstName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('firstName', $event)"
						(searchInputChanged)="onSearchInput('firstName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientLastName">Client Last Name</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="last-name-typeahead"
						[allDropdownOptions]="lastNames"
						[filterOnField]="'lastName'"
						[placeholderText]="this.lastNameMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="lastName"
						[initiallySelectedIdField]="'lastName'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('lastName', $event)"
						(searchInputChanged)="onSearchInput('lastName', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>

			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@inventoryReportDialog-clientIdn">Client IDN</h3>
				<app-loading-indicator
					[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
					diameter="30"
				>
					<app-multi-select-typeahead
						data-automation-id="client-idn-typeahead"
						[allDropdownOptions]="clientIdns"
						[filterOnField]="'idn'"
						[placeholderText]="this.clientIdnMultiSelectSearchPlaceholder"
						[showSelectionsInInputField]="false"
						[showSelectedItemSubOption]="false"
						[selectedItemIconName]="'sl-lock'"
						[showSelectedItemMessage]="false"
						[initiallySelectedItemIds]="clientIdn"
						[initiallySelectedIdField]="'idn'"
						[minCharactersForSearch]="2"
						(selectedOptionsChangedEvent)="onSelectedItemsChanged('clientIdn', $event)"
						(searchInputChanged)="onSearchInput('clientIdn', $event)"
					>
					</app-multi-select-typeahead>
				</app-loading-indicator>
			</div>

			<mat-divider></mat-divider>
		}

		<h3 class="drawer-dialog-content-header" i18n="@@accessReportDialog-propertyNames">Property Names</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				[allDropdownOptions]="propertyOptions"
				[filterOnField]="'name'"
				data-automation-id="property-options-typeahead"
				[placeholderText]="this.propertyMultiSelectorSearchPlaceHolder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-lock'"
				[showSelectedItemMessage]="false"
				[initiallySelectedItemIds]="propertyIds"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
				(searchInputChanged)="onSearchInput('property', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>

		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@assignDeviceControl-timeFrameHeader">Timeframe</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@accessReportDialog-startDate">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="startPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@accessReportDialog-chooseStartDate"
					(dateChange)="onStartDateChanged($event)"
					[ngModel]="this.accessReportFilters.visitStartDate"
					data-automation-id="start-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="startPicker"
					data-automation-id="start-date-toggle"
				>
				</mat-datepicker-toggle>
				<mat-datepicker #startPicker data-automation-id="start-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@accessReportHeader-endDate">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="endPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@accessReportDialog-chooseEndDate"
					(dateChange)="onEndDateChanged($event)"
					[ngModel]="this.accessReportFilters.visitEndDate"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="endPicker"
					data-automation-id="end-date-toggle"
				>
				</mat-datepicker-toggle>
				<mat-datepicker #endPicker data-automation-id="end-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				(click)="onCloseDialog()"
				i18n="@@accessReportDialog-closeWindow"
				data-automation-id="access-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="access-report-generate-report-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
